import Image from "next/image";

import type { Distributor as DistributorType } from "@sorcery/db";
import { ExternalLink } from "@sorcery/ui";
import { beautify } from "@sorcery/utils/universal/string";

export const Distributor = ({
  distributor,
  className = "",
  large = false,
}: {
  distributor: DistributorType;
  className?: string;
  large?: boolean;
}) => {
  return (
    <ExternalLink
      href={distributor.link}
      target="_blank"
      className={`flex items-center truncate whitespace-nowrap py-2 ${className}`}
    >
      <Image
        className="inline"
        src={distributor.logoSrc}
        height={50 * (large ? 2 : 1)}
        width={75 * (large ? 2 : 1)}
        alt={""}
      />
      <div className={"ml-4 block"}>
        <div className="truncate">{distributor.name}</div>
        <div className={"truncate text-xl italic opacity-60"}>
          {beautify(distributor.region, true)}
        </div>
      </div>
    </ExternalLink>
  );
};
